<template>
  <div class="selected-item">
    <div class="selected-item__wrp">
      <div class="selected-item__name">
        <img
          :src="`/img/power-calculator/${dataItem.icon}.svg`"
          :alt="_T(dataItem.altImg)"
        />
        <span>{{ _T(dataItem.title) }}</span>
      </div>

      <div class="selected-item__power">
        <span class="selected-item__dropdown-title">{{ _T("@Power") }}</span>
        <InputDropdown :item-data="dataItem" />
      </div>

      <div class="selected-item__time">
        <span class="selected-item__dropdown-title">{{
          _T("@Opening hours")
        }}</span>

        <div class="selected-item__time-wrp">
          <TimeCounter :item-data="dataItem" />
          <Dropdown :item-data="dataItem" />
        </div>
      </div>
    </div>
    <button class="selected-item__del" @click="delElement(dataItem)">
      <img src="@/assets/icons/trash.svg" alt="delete item" />
    </button>
  </div>
</template>

<script setup>
import TimeCounter from "~~/modules/calculators/powerCalculator/components/UI/TimeCounter.vue";
import Dropdown from "~~/modules/calculators/powerCalculator/components/UI/Dropdown.vue";
import InputDropdown from "~~/modules/calculators/powerCalculator/components/UI/InputDropdown.vue";
import { usePowerCalcStore } from "~/store/powerCalcStore";

const powerCalcStore = usePowerCalcStore();

const props = defineProps({
  dataItem: { type: Object, required: true },
});

function delElement(el) {
  powerCalcStore.removeSelectedItem(el);
}
</script>

<style lang="scss" scoped>
.selected-item {
  @include flex-container(row, space-between, center);

  border-radius: 30px;

  padding: 8px 16px;

  @include bigMobile() {
    position: relative;

    border-radius: 16px;

    padding: 8px;
  }

  &__wrp {
    max-width: 930px;
    width: 100%;

    @include flex-container(row, space-between, center);

    gap: 16px;

    @include bigMobile() {
      @include flex-container(column, flex-start, flex-start);
    }
  }

  &__name {
    max-width: 412px;
    width: 100%;

    @include flex-container(row, flex-start, center);

    gap: 10px;

    @include bigMobile() {
      padding-left: 8px;

      img {
        max-width: 22px;
      }
    }

    span {
      @include font(16, 22, 600);
      color: var(--color-grey-900);
    }
  }

  &__time {
    max-width: 305px;
    width: 100%;

    @include bigMobile() {
      max-width: none;

      @include flex-container(row, space-between, center);

      gap: 4px;
    }
  }

  &__time-wrp {
    @include flex-container(row, space-between, center);

    gap: 8px;
  }

  &__power {
    max-width: 135px;
    width: 100%;

    @include bigMobile() {
      max-width: none;

      @include flex-container(row, space-between, center);

      gap: 4px;
    }
  }

  &__dropdown-title {
    display: none;

    @include font(12, 18, 500);
    color: var(--color-grey-900);

    @include bigMobile() {
      display: inline;
    }
  }

  &__del {
    @include bigMobile() {
      position: absolute;
      top: 8px;
      right: 16px;
    }
  }
}
</style>
